import httpAuth from "../../services/httpAuth";
import { getNewsError, getNewsSuccess } from "./news.slice";

export const requestNews = () => async (dispatch) => {
  try {
    const response = await httpAuth.post(`news/getNews`);

    if (response.data.status) {
      dispatch(getNewsSuccess(response.data));
    }
    return response;
  } catch (e) {
    dispatch(getNewsError());
  }
};
